// import AppAlertComponent from '@/app/common/components/AppAlertComponent/AppAlertComponent'
// import { buttonVariants } from '@/app/common/components/Button'
import { LOCAL_STORAGE_KEYS } from '@/app/common/local-storage'
import { RootState } from '@/storage/store'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
// import { Link } from 'react-router-dom'
import { z } from 'zod'
// import useFamilyApplicationRouting from '../../routing/useFamilyApplicationRouting'
// import { getStudentDetailsStartRoute } from '../../utils'
import SubmitIdentity from './_components/SubmitIdentity'
import VerificationErrorMessage from './_components/VerificationErrorMessage'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import ResidencyVerifyInstructionsPage
  from '@/app/pages/family_application/residency_verification/ResidencyVerifyInstructionsPage.tsx'

function IdentitySubmittedPage() {
  const { t: translate } = useTranslation()
  const [token, setToken] = useState('')
  const [status, setStatus] = useState<'loading' | 'error' | 'success'>(
    'loading'
  )
  const programId = useSelector(
    (state: RootState) => state?.ProgramSettings?.data?.id
  )
  const application = useSelector(selectFamilyApplication)
  // const { onModuleEnd } = useFamilyApplicationRouting(application)

  useEffect(() => {
    const unverifiedToken = localStorage.getItem(LOCAL_STORAGE_KEYS.clearme_id)

    const token = z.string().min(1).safeParse(unverifiedToken)

    if (token.success) {
      setToken(token.data)
      setStatus('success')
    } else {
      setStatus('error')
    }
  }, [])

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.clearme_id)
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  if (application?.address && !token) {
    // const nextRoute = onModuleEnd(getStudentDetailsStartRoute(application))

    return (
      <ResidencyVerifyInstructionsPage/>
    )
  }

  if (status === 'loading') {
    return null
  }

  if (status === 'error' || !programId) {
    return <VerificationErrorMessage title={translate('identity_error')} variant="warning" />
  }

  return <SubmitIdentity token={token} programId={programId} />
}

export default IdentitySubmittedPage
